import React, { useMemo } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import InputField from '../../components/form/InputField'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import { useForm, useField } from 'react-form'

function Field(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <InputField {...props} input={getInputProps()} />
}

const CourseFormPopup = props => {
  const { course, defaultValues, handleSubmit, onClose, errors, isSubmitting } = props
  const { Form } = useForm({
    defaultValues: useMemo(()=>defaultValues,[]),
    onSubmit: (values,instance)=>handleSubmit(values)
  })

  return(
    <div className='popup-content new-course-popup popup dialog simple-popup tyto-popup dialog--open'>
      <div onClick={onClose} className='popup-background'></div>
      <div className="dialog__content">
        <div className="container-fluid">
          <div className="dialog__overview">
            <h1>{!_.isEmpty(course) ? `Edit ${course.name}` : 'New Course'}</h1>
            <p>A course/subject is an organizational unit for your classes.</p>
            <p>For example, you could create a "5th Grade Science" course or a "Biology" subject. You can group analytics by these units later when your students have completed assignments.</p>
            <button onClick={onClose} className="popup-close close action top-right" data-dialog-close=""><i className="fa fa-times"></i></button>
            <br/>

            <Form id='course-form'>
              <Field label='Name' name='name'/>

              <br/>
              <button type='submit' disabled={isSubmitting} className='btn btn-primary'>Save</button>
              <img className={`loading-gif ${(isSubmitting) ? '' : 'hidden'}`} src={loadingGif}/>
              {!_.isEmpty(errors) && <p className='error'>{errors}</p>}
              <br/><br/><br/>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseFormPopup;
